module.exports = __webpack_public_path__ + "assets/img/43633bbe86949c9264b485ca6ed6f382.png";